export default __webpack_public_path__ + "static/media/MountainHuntingLodge.699907a7.jpg";